import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSensor = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm0 2c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm3 5c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1H9c-.552 0-1-.448-1-1V9c0-.552.448-1 1-1h6zm-1 2h-4v4h4v-4z"
	})
});
export default SvgSensor;
